function countRows(elements) {
  return new Set(elements.map((el) => el.offsetTop)).size;
}

export function getSortedFieldEntries(fields) {
  if (!fields || typeof fields !== 'object' || Array.isArray(fields)) {
    return [];
  }

  return Object.entries(fields)
    .filter(([, value]) => value && typeof value === 'object')
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      key,
      label: value.display_name || value.field_id,
    }));
}

export function getMaxVisibleFieldTags(measureEl, totalCount, maxRows = 2) {
  const tags = [...measureEl.querySelectorAll('[data-field-tag]')];
  const overflowChip = measureEl.querySelector('[data-overflow-chip]');
  if (!tags.length) return 0;

  if (countRows(tags) <= maxRows) return totalCount;

  for (let visible = totalCount - 1; visible >= 0; visible -= 1) {
    const layout = overflowChip ? [...tags.slice(0, visible), overflowChip] : tags.slice(0, visible);
    if (countRows(layout) <= maxRows) return visible;
  }

  return 0;
}
